import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import XPProgressHeader from '../../components/ui/XPProgressHeader';
import AIChatbot from '../../components/ui/AIChatbot';
import WelcomeBanner from './components/WelcomeBanner';
import QuickStats from './components/QuickStats';
import ROIWidget from './components/ROIWidget';
import OnboardingChecklist from './components/OnboardingChecklist';
import UpcomingEvents from './components/UpcomingEvents';

const MainDashboard = () => {
  const [currentXP, setCurrentXP] = useState(0);
  const [recentGain, setRecentGain] = useState(0);
  const [level, setLevel] = useState('Rookie');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const levels = [
    { name: 'Rookie', minXP: 0, maxXP: 500 },
    { name: 'Newbie', minXP: 500, maxXP: 1000 },
    { name: 'Learner', minXP: 1000, maxXP: 2000 },
    { name: 'Contributor', minXP: 2000, maxXP: 3500 },
    { name: 'Colleague', minXP: 3500, maxXP: 5000 }
  ];

  const handleTaskComplete = (xpGained) => {
    setRecentGain(xpGained);
    const newXP = currentXP + xpGained;
    setCurrentXP(newXP);

    const newLevel = levels?.find(
      (lvl) => newXP >= lvl?.minXP && newXP < lvl?.maxXP
    );
    if (newLevel && newLevel?.name !== level) {
      setLevel(newLevel?.name);
    }
  };

  const currentLevelData = levels?.find((lvl) => lvl?.name === level);
  const totalXPForLevel = currentLevelData ? currentLevelData?.maxXP : 1000;

  return (
    <div className="min-h-screen bg-background">
      <Sidebar onToggleCollapse={setIsSidebarCollapsed} />
      <XPProgressHeader
        currentXP={currentXP}
        level={level}
        totalXP={totalXPForLevel}
        recentGain={recentGain}
      />
      
      <main className="lg:ml-60 pt-20 min-h-screen">
        <div className="p-6 space-y-6">
          <WelcomeBanner />
          
          <QuickStats />
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2 space-y-6">
              <ROIWidget />
              <OnboardingChecklist onTaskComplete={handleTaskComplete} />
            </div>
            
            <div className="space-y-6">
              <UpcomingEvents />
              
              <div className="bg-card rounded-lg shadow-elevation-2 border border-border p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                    <span className="text-2xl">🐝</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground">Need Help?</h3>
                    <p className="text-xs text-muted-foreground">Ask Bee anything</p>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground mb-4">
                  Your AI assistant is ready to help with onboarding questions, company info, and more.
                </p>
                <div className="space-y-2">
                  <button className="w-full py-2 px-3 bg-muted/50 hover:bg-muted rounded-lg text-sm text-foreground text-left transition-colors duration-150 flex items-center gap-2">
                    <span>🔑</span>
                    <span>What's the WiFi password?</span>
                  </button>
                  <button className="w-full py-2 px-3 bg-muted/50 hover:bg-muted rounded-lg text-sm text-foreground text-left transition-colors duration-150 flex items-center gap-2">
                    <span>🏖️</span>
                    <span>How do I request time off?</span>
                  </button>
                  <button className="w-full py-2 px-3 bg-muted/50 hover:bg-muted rounded-lg text-sm text-foreground text-left transition-colors duration-150 flex items-center gap-2">
                    <span>💰</span>
                    <span>Tell me about investment opportunities</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <AIChatbot />
    </div>
  );
};

export default MainDashboard;